import equalByNameAndPaymentParamId from '../../utils/equalByNameAndPaymentParamId';
import {i18n} from "../../../vue-i18n";

export default class ReclassSecurityPayment {
  constructor(paymentParametersId, rateValue) {
    this.commandName = "ReclassSecurityPayment";
    this.paymentId = paymentParametersId;
    this.paymentRate = rateValue;

    this.description =
      `${i18n.t('CONTENT.payments.paymentRate')}: ${rateValue}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentId: this.paymentId,
        PaymentRate: this.paymentRate
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParamId(this, other);
}
